<template>
  <form class="form form-vertical">
      <div class="form-body">
        <div class="row">
          <vx-input-group class="mb-2">          
            <vs-input
              label="Emails para envio"
              v-model="test_emails"
              class="w-full"
              name="test_emails"
              v-validate="'required'"
              placeholder="Ex: email1@email.com,email2@email.com"
              description-text="Utilize vírgulas para separar múltiplos endereços de email"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('test_emails')"
            >
              {{ errors.first('test_emails') }}
            </span>
          </vx-input-group>

          <!-- Submit -->
          <vx-input-group>
            <vs-button @click="submitData" :disabled="!isFormValid">
              Enviar Teste
            </vs-button>
          </vx-input-group>
        </div>
      </div>
  </form>
</template>

<script>
export default {
  name: 'test-campaign-popup',
  data() {
    return {
      test_emails: ''
    }
  },
  methods: {
    submitData() {
      if (this.test_emails !== '') {
        this.$emit("sendTestMail", this.test_emails.replace(/\s/g, ''))
      }
    }
  },
  computed: {
    isFormValid() {
      return !this.errors.any()
    }
  },
}
</script>